import { DataChangeStruct, PythaEventName, UpdateType } from "pytha2";
import { EngineContext, SystemContext } from "@/App";
import { MObjectPrimitive } from "@/declare/interface/primitive";
import { useContext, useEffect, useState } from "react"
import { Point } from "tnbase";
import MObjectLabelItem from "./mobject-label";

interface IProps {
    mobjectPrimitiveList: MObjectPrimitive[]
}

export default function MObjectLabelMain(props: IProps) {

    const { mobjectPrimitiveList } = props

    /**
     * 是否显示构件（视图变换的时候发生修改）
     */
    const [showLabel, setShowLabel] = useState<boolean>(true)
    /**
     * 刷新页面dom
     */
    const [, setUpdateLabel] = useState<number>(0)
    /**
     * 可以展示的
     */

    const systemContext = useContext(SystemContext)

    /**
     * 引擎上下文，用于管理全局的引擎实例。
     */
    const engineContext = useContext(EngineContext);

    useEffect(() => {
        if (!engineContext.engine) return

        const unsubscribe = engineContext.engine.eventMediator.noticeHandler?.onNotice?.subscribe((sender, event) => {
            if (event.cmd === PythaEventName.DATA_CHANGE) {
                let data = event?.data as DataChangeStruct;
                if (!data) return;

                // 监听视图变换
                if (data?.viewChangeStart) {
                    setShowLabel(false)
                    setUpdateLabel(pre => pre + 1)
                }
                if (data?.viewChangeEnd) {
                    setShowLabel(true)
                    setUpdateLabel(pre => pre + 1)
                }

                // 监听选择变化
                if (data?.selectChanged) {
                    let selectPrimitives = engineContext.engine.storage.selectStore.selectPrimitives
                    if (selectPrimitives?.length > 0) {
                        let selectPri = selectPrimitives[0]
                        let mobj = mobjectPrimitiveList.find(mobj => mobj.primitive_uuid == selectPri.uuid)
                        if (mobj) {
                            systemContext.setActiveMonitorObjectId(mobj.id)
                            systemContext.setShowMObjectLabelDetailList([
                                ...systemContext.showMObjectLabelDetailList,
                                mobj.id
                            ])
                        }
                    }
                }
            }
        });

        return (() => {
            unsubscribe?.()
        })
    }, [engineContext.engine, mobjectPrimitiveList])

    /**
     * 监听打开的监测对象，选中对应图元
     */
    useEffect(() => {
        if (!systemContext.activeMonitorObjectId) return
        if (!engineContext.engine) return
        let mobject = mobjectPrimitiveList.find(i => i.id == systemContext.activeMonitorObjectId)
        if (!mobject || !mobject.primitive_uuid) return
        let pri = engineContext.engine.storage.primitiveStore.primitiveDict[mobject.primitive_uuid]
        if (!pri) return
        let pris = engineContext.engine.storage.selectStore.selectPrimitives
        pris.forEach(p => {
            p.isSelected = false
            p.needRedraw = true
        })
        pri.needRedraw = true
        pri.isSelected = true
        engineContext.engine.storage.selectStore.selectPrimitives = [pri]
        engineContext.engine.eventMediator.renderHandler.render(true, UpdateType.MAIN)

    }, [systemContext.activeMonitorObjectId])

    useEffect(() => {
        document.addEventListener("keydown", onDocumentKeyDown)

        return (() => {
            document.removeEventListener("keydown", onDocumentKeyDown)
        })
    }, [])

    const onDocumentKeyDown = (event) => {
        let code = event.code;
        if (code === "Escape") {
            systemContext.setShowMObjectLabelDetailList([])
            systemContext.setActiveMonitorObjectId(null)
        }
    }

    return (
        <div>
            {showLabel && (
                <>
                    {mobjectPrimitiveList?.filter(i =>
                        i.primitive_center &&
                        i.primitive_uuid &&
                        // (!engineContext?.engine?.storage?.primitiveStore?.primitiveDict[i.primitive_uuid]?.hidden) &&
                        (
                            systemContext?.activeGroupUuids?.length === 0 ? true :
                                engineContext?.engine?.storage?.primitiveStore?.primitiveDict[i.primitive_uuid]?.group?.some(g => systemContext?.activeGroupUuids?.includes(g))
                        ) &&
                        (systemContext.monitorObjectTypeList.includes(i.type) || systemContext.showMObjectLabelDetailList.includes(i.id))
                    ).map(mobjectItem => (
                        <MObjectLabelItem mobject={mobjectItem} />
                    ))}
                </>
            )}
        </div>
    )
}